export enum ServerEndpoints {
  Administration_Contract_GetCurretCompany = "/Administration/Contract/GetCurretCompany",
  Administration_MigrationAssistant_Event_Register_Patch_20231003 = "/Administration/MigrationAssistant/Event_Register_Patch_20231003",
  Administration_MigrationAssistant_GetPatches = "/Administration/MigrationAssistant/GetPatches",
  Administration_MigrationAssistant_InventoryNumber_Patch_20230909 = "/Administration/MigrationAssistant/InventoryNumber_Patch_20230909",
  Administration_MigrationAssistant_Legal_Germany_Submission_PushDevices_Patch_20250729 = "/Administration/MigrationAssistant/Legal_Germany_Submission_PushDevices_Patch_20250729",
  Administration_MigrationAssistant_Vat_Patch_20230912 = "/Administration/MigrationAssistant/Vat_Patch_20230912",
  Administration_Permission_List = "/Administration/Permission/List",
  Administration_Role_Add = "/Administration/Role/Add",
  Administration_Role_AddUser = "/Administration/Role/AddUser",
  Administration_Role_Delete = "/Administration/Role/Delete",
  Administration_Role_Get = "/Administration/Role/Get",
  Administration_Role_List = "/Administration/Role/List",
  Administration_Role_RemoveUser = "/Administration/Role/RemoveUser",
  Administration_Role_TogglePermission = "/Administration/Role/TogglePermission",
  Administration_Settings_GetLogo = "/Administration/Settings/GetLogo",
  Administration_Settings_GetShiftMakerSettings = "/Administration/Settings/GetShiftMakerSettings",
  Administration_Settings_GetTimezone = "/Administration/Settings/GetTimezone",
  Administration_Settings_SetLogo = "/Administration/Settings/SetLogo",
  Administration_Settings_SetShiftMakerSettings = "/Administration/Settings/SetShiftMakerSettings",
  Administration_Settings_SetTimezone = "/Administration/Settings/SetTimezone",
  Administration_User_Add = "/Administration/User/Add",
  Administration_User_Delete = "/Administration/User/Delete",
  Administration_User_Get = "/Administration/User/Get",
  Administration_User_List = "/Administration/User/List",
  Administration_User_ListCompanyUser = "/Administration/User/ListCompanyUser",
  Administration_User_ListOwners = "/Administration/User/ListOwners",
  Analysis_EventAnalysis_FetchEventData = "/Analysis/EventAnalysis/FetchEventData",
  Analysis_EventAnalysis_GetEventsLike = "/Analysis/EventAnalysis/GetEventsLike",
  // Monolith — the platform-owner account directory and the audited second-factor reset (#279 completing #282).
  // A filtered sibling of the admin link picker's `/auth/account/admin/external-identities`, not a widening of
  // it: that one feeds a picker and must not pay for a second-factor join it never shows.
  Auth_Account_Admin_Identities = "/auth/account/admin/identities",
  Auth_Account_Admin_Identity_TwoFactorReset_$identityId$ = "/auth/account/admin/identities/$identityId$/two-factor/reset",
  Automation_Scheduler_DeleteGroup = "/Automation/Scheduler/DeleteGroup",
  Automation_Scheduler_GetSchedulerGroup = "/Automation/Scheduler/GetSchedulerGroup",
  Automation_Scheduler_GetSchedulerObjects = "/Automation/Scheduler/GetSchedulerObjects",
  Automation_Scheduler_ScheduleGroup = "/Automation/Scheduler/ScheduleGroup",
  Automation_Workflow_Add = "/Automation/Workflow/Add",
  Automation_Workflow_Delete_$id$ = "/Automation/Workflow/Delete/$id$",
  Automation_Workflow_Get_$id$ = "/Automation/Workflow/Get/$id$",
  Automation_Workflow_List = "/Automation/Workflow/List",
  Automation_Workflow_SetValue_$id$ = "/Automation/Workflow/SetValue/$id$",
  Booking_Area_Add = "/Booking/Area/Add",
  Booking_Area_Delete = "/Booking/Area/Delete",
  Booking_Area_Get = "/Booking/Area/Get",
  Booking_Area_List = "/Booking/Area/List",
  Booking_Area_Upsert = "/Booking/Area/Upsert",
  Booking_Area_UpsertList = "/Booking/Area/UpsertList",
  Booking_FloorPlan_Delete = "/Booking/FloorPlan/Delete",
  Booking_FloorPlan_Get = "/Booking/FloorPlan/Get",
  Booking_FloorPlan_Image = "/Booking/FloorPlan/Image",
  Booking_FloorPlan_Update = "/Booking/FloorPlan/Update",
  Booking_FloorPlan_Upload = "/Booking/FloorPlan/Upload",
  Booking_Order_GetOrderCountFromShard = "/Booking/Order/GetOrderCountFromShard",
  Booking_Order_List = "/Booking/Order/List",
  Booking_Order_SetActiveState = "/Booking/Order/SetActiveState",
  Booking_Reference_Get_$id$_v2025_4 = "/v2025.4/Booking/Reference/Get/$id$",
  Booking_Reference_List_$type$_v2025_4 = "/v2025.4/Booking/Reference/List/$type$",
  Booking_Reference_Load_$type$_$id$ = "/Booking/Reference/Load/$type$/$id$",
  Booking_Reference_Load_$type$_v2025_4 = "/v2025.4/Booking/Reference/Load/$type$",
  Booking_Reference_LoadActiveIdentifiers_$type$ = "/Booking/Reference/LoadActiveIdentifiers/$type$",
  Booking_Reference_Prepare = "/Booking/Reference/Prepare",
  Booking_Reference_Prepare__v2025_4 = "/v2025.4/Booking/Reference/Prepare",
  Booking_Reference_RegisterExpected_$id$ = "/Booking/Reference/RegisterExpected/$id$",
  Booking_Reference_RegisterExpected_$id$_v2025_4 = "/v2025.4/Booking/Reference/RegisterExpected/$id$",
  // #204: the web-management spending-limit change (v2025_4.ReferenceController.SetSpendingLimit — distinct
  // from the register's own step-up-gated action of the same name on the unversioned ReferenceController).
  Booking_Reference_SetSpendingLimit_$id$_v2025_4 = "/v2025.4/Booking/Reference/SetSpendingLimit/$id$",
  Booking_Table_Add = "/Booking/Table/Add",
  Booking_Table_Delete = "/Booking/Table/Delete",
  Booking_Table_Get = "/Booking/Table/Get",
  Booking_Table_List = "/Booking/Table/List",
  Booking_Table_Upsert = "/Booking/Table/Upsert",
  Booking_Table_UpsertList = "/Booking/Table/UpsertList",
  Communication_Scheduler_AddTelegramMessage = "/Communication/Scheduler/AddTelegramMessage",
  Communication_Scheduler_List = "/Communication/Scheduler/List",
  Communication_Scheduler_ListTelegramMessages = "/Communication/Scheduler/ListTelegramMessages",
  Communication_Scheduler_RemoveTelegramMessage = "/Communication/Scheduler/RemoveTelegramMessage",
  Company_Company_GetCompanyShards = "/Company/Company/GetCompanyShards",
  Company_Company_List = "/Company/Company/List",
  Company_CompanyTimeZone_Get = "/Company/CompanyTimeZone/Get",
  Company_Employee_Add = "/Company/Employee/Add",
  Company_Employee_AllowEmployeeLogin = "/Company/Employee/AllowEmployeeLogin",
  Company_Employee_ChangeName = "/Company/Employee/ChangeName",
  Company_Employee_EndEmployment = "/Company/Employee/EndEmployment",
  Company_Employee_Rehire = "/Company/Employee/Rehire",
  Company_Employee_UpdateEmploymentPeriod = "/Company/Employee/UpdateEmploymentPeriod",
  Company_Employee_EmployeeSalesList = "/Company/Employee/EmployeeSalesList",
  Company_Employee_EmployeeSalesOrders = "/Company/Employee/EmployeeSalesOrders",
  Company_Employee_Get = "/Company/Employee/Get",
  Company_Employee_GetEmployeeShiftList = "/Company/Employee/GetEmployeeShiftList",
  Company_Employee_GetEmploymentRelationships_$id$ = "/Company/Employee/GetEmploymentRelationships/$id$",
  Company_Employee_GetRestricted = "/Company/Employee/GetRestricted",
  Company_Employee_GetStats_$employee$ = "/Company/Employee/GetStats/$employee$",
  Company_Employee_List = "/Company/Employee/List",
  Company_Employee_ListMinimal = "/Company/Employee/ListMinimal",
  Company_Employee_ListNl = "/Company/Employee/ListNl",
  Company_Employee_RequestVerification = "/Company/Employee/RequestVerification",
  Company_Employee_ResetSocial = "/Company/Employee/ResetSocial",
  Company_Employee_SetNewPassword = "/Company/Employee/SetNewPassword",
  Company_Employee_ResetPin = "/Company/Employee/ResetPin",
  Company_Employee_SetEmployeeIdentification = "/Company/Employee/SetEmployeeIdentification",
  Company_Employee_SetPublicProperty = "/Company/Employee/SetPublicProperty",
  Company_Employee_SetSocial = "/Company/Employee/SetSocial",
  Company_Employee_SetValue_$employee$ = "/Company/Employee/SetValue/$employee$",
  Company_Employee_WorktimeStats = "/Company/Employee/WorktimeStats",
  Company_EmployeeAttribute_Add = "/Company/EmployeeAttribute/Add",
  Company_EmployeeAttribute_ChangeName = "/Company/EmployeeAttribute/ChangeName",
  Company_EmployeeAttribute_ChangeShortName = "/Company/EmployeeAttribute/ChangeShortName",
  Company_EmployeeAttribute_Delete = "/Company/EmployeeAttribute/Delete",
  Company_EmployeeAttribute_Get = "/Company/EmployeeAttribute/Get",
  Company_EmployeeAttribute_List = "/Company/EmployeeAttribute/List",
  Company_EmployeeAttribute_SetEmployeeAttributes = "/Company/EmployeeAttribute/SetEmployeeAttributes",
  Company_EmploymentRelationship_Add = "/Company/EmploymentRelationship/Add",
  Company_EmploymentRelationship_ChangeName = "/Company/EmploymentRelationship/ChangeName",
  Company_EmploymentRelationship_Delete = "/Company/EmploymentRelationship/Delete",
  Company_EmploymentRelationship_Get = "/Company/EmploymentRelationship/Get",
  Company_EmploymentRelationship_GetEventEmploymentCosts = "/Company/EmploymentRelationship/GetEventEmploymentCosts",
  Company_EmploymentRelationship_GetEventsEmploymentCosts = "/Company/EmploymentRelationship/GetEventsEmploymentCosts",
  Company_EmploymentRelationship_List = "/Company/EmploymentRelationship/List",
  Company_EmploymentRelationship_SetRelationship = "/Company/EmploymentRelationship/SetRelationship",
  Company_EmploymentRelationship_SetValues = "/Company/EmploymentRelationship/SetValues",
  // The shift plan's ("Dienstplan") one read surface (#409). It replaces the five day reads the screen used to
  // make across four controllers plus the calendar read — see `ShiftPlanHttpService`. The legacy endpoints they
  // pointed at are unchanged and still serve their other callers; they are just no longer this screen's door.
  Company_ShiftPlan_Day__v2026_8 = "/v2026.8/Company/ShiftPlan/Day",
  Company_ShiftPlan_Calendar__v2026_8 = "/v2026.8/Company/ShiftPlan/Calendar",
  Company_Setting_List = "/Company/Setting/List",
  Company_Setting_SetAuthPair = "/Company/Setting/SetAuthPair",
  Company_Setting_SetAuthPairs = "/Company/Setting/SetAuthPairs",
  Company_Setting_SumUpIsConfigured = "/Company/Setting/SumUpIsConfigured",
  Company_Setting_TelegramIsConfigured = "/Company/Setting/TelegramIsConfigured",
  Company_Supplier_Add = "/Company/Supplier/Add",
  Company_Supplier_ChangeName = "/Company/Supplier/ChangeName",
  Company_Supplier_Delete = "/Company/Supplier/Delete",
  Company_Supplier_Get = "/Company/Supplier/Get",
  Company_Supplier_List = "/Company/Supplier/List",
  Company_Supplier_Update = "/Company/Supplier/Update",
  Company_Telegram_AddBot = "/Company/Telegram/AddBot",
  Company_Telegram_AddChannel = "/Company/Telegram/AddChannel",
  Company_Telegram_DeleteBot = "/Company/Telegram/DeleteBot",
  Company_Telegram_DeleteChannel = "/Company/Telegram/DeleteChannel",
  Company_Telegram_GetBots = "/Company/Telegram/GetBots",
  Company_Telegram_GetChannelSettings = "/Company/Telegram/GetChannelSettings",
  Company_Telegram_List = "/Company/Telegram/List",
  Company_Telegram_SetChannelSettings = "/Company/Telegram/SetChannelSettings",
  Device_CashPointEntry_Close_$device$ = "/Device/CashPointEntry/Close/$device$",
  Device_CashPointEntry_CurrentBusinessCases_$device$ = "/Device/CashPointEntry/CurrentBusinessCases/$device$",
  Device_CashPointEntry_CurrentSummary_$device$ = "/Device/CashPointEntry/CurrentSummary/$device$",
  Device_CashPointEntry_GetBusinessCaseTypeSummary_$device$ = "/Device/CashPointEntry/GetBusinessCaseTypeSummary/$device$",
  Device_CashPointEntry_GetLastClosed_$device$ = "/Device/CashPointEntry/GetLastClosed/$device$",
  Device_CashPointEntry_GetOpen_$device$ = "/Device/CashPointEntry/GetOpen/$device$",
  Device_CashPointEntry_GetSummary_$device$ = "/Device/CashPointEntry/GetSummary/$device$",
  Device_CashPointEntry_List = "/Device/CashPointEntry/List",
  Device_CashPointEntry_Open_$device$ = "/Device/CashPointEntry/Open/$device$",
  Device_CashPointEntry_PrepareForClosing_$device$ = "/Device/CashPointEntry/PrepareForClosing/$device$",
  Device_CashPointEntry_Summary = "/Device/CashPointEntry/Summary",
  Device_Client_CheckOrderStatus_$device$ = "/Device/Client/CheckOrderStatus/$device$",
  Device_Client_GetData = "/Device/Client/GetData",
  Device_Client_GetData__v2025_4 = "/v2025.4/Device/Client/GetData",
  Device_Client_ProcessTransactions = "/Device/Client/ProcessTransactions",
  Device_Information_ChangeName = "/Device/Information/ChangeName",
  Device_Information_Delete = "/Device/Information/Delete",
  Device_Information_Get = "/Device/Information/Get",
  Device_Information_List = "/Device/Information/List",
  // Monolith — one-time register setup codes (#263). The screen that displays them is #469 step 5.
  Device_Enrollment = "/device/enrollment",
  // Monolith — the reusable per-shard client id + password a register signs in with (#469). The screen that
  // issues, rotates and revokes them is #469 step 7. Its account picker deliberately calls
  // `Device_Enrollment` + "/accounts" instead of a listing of its own: both doors decide anchor eligibility
  // with the ONE predicate `DeviceAnchorEligibility.Ineligibility` (#279), so one listing serves both.
  Device_Credentials = "/device/credentials",
  Device_Information_RequestInformation = "/Device/Information/RequestInformation",
  Device_Information_SetLockedOut = "/Device/Information/SetLockedOut",
  Device_Printer_Add = "/Device/Printer/Add",
  Device_Printer_ChangeName_$id$ = "/Device/Printer/ChangeName/$id$",
  Device_Printer_Delete_$id$ = "/Device/Printer/Delete/$id$",
  Device_Printer_Get_$id$ = "/Device/Printer/Get/$id$",
  Device_Printer_List = "/Device/Printer/List",
  Device_Printer_SetVariable_$id$ = "/Device/Printer/SetVariable/$id$",
  Document_Employee_Download = "/Document/Employee/Download",
  Document_Employee_DownloadIndividualDetails = "/Document/Employee/DownloadIndividualDetails",
  Document_EmploymentRelationship_Download = "/Document/EmploymentRelationship/Download",
  Document_ShiftMaker_Download = "/Document/ShiftMaker/Download",
  Inventory_BusinessCase_Add = "/Inventory/BusinessCase/Add",
  Inventory_BusinessCase_Delete_$id$ = "/Inventory/BusinessCase/Delete/$id$",
  Inventory_BusinessCase_Get_$id$ = "/Inventory/BusinessCase/Get/$id$",
  Inventory_BusinessCase_List = "/Inventory/BusinessCase/List",
  Inventory_Category_Add = "/Inventory/Category/Add",
  Inventory_Category_ChangeName = "/Inventory/Category/ChangeName",
  Inventory_Category_Delete = "/Inventory/Category/Delete",
  Inventory_Category_Get = "/Inventory/Category/Get",
  Inventory_Category_List = "/Inventory/Category/List",
  Inventory_Component_Add = "/Inventory/Component/Add",
  Inventory_Component_ChangeName = "/Inventory/Component/ChangeName",
  Inventory_Component_Delete = "/Inventory/Component/Delete",
  Inventory_Component_Get = "/Inventory/Component/Get",
  Inventory_Component_List = "/Inventory/Component/List",
  Inventory_Composition_Add = "/Inventory/Composition/Add",
  Inventory_Composition_ChangeName = "/Inventory/Composition/ChangeName",
  Inventory_Composition_ChangePublicProperty = "/Inventory/Composition/ChangePublicProperty",
  Inventory_Composition_ComponentChange = "/Inventory/Composition/ComponentChange",
  Inventory_Composition_Create = "/Inventory/Composition/Create",
  Inventory_Composition_Delete = "/Inventory/Composition/Delete",
  Inventory_Composition_Download = "/Inventory/Composition/Download",
  Inventory_Composition_Get = "/Inventory/Composition/Get",
  Inventory_Composition_List = "/Inventory/Composition/List",
  Inventory_Composition_PriceChange = "/Inventory/Composition/PriceChange",
  Inventory_Composition_SetOrder = "/Inventory/Composition/SetOrder",
  Inventory_Composition_ToggleTag = "/Inventory/Composition/ToggleTag",
  Inventory_Composition_Upsert = "/Inventory/Composition/Upsert",
  Inventory_CompositionType_Add = "/Inventory/CompositionType/Add",
  Inventory_CompositionType_ChangeName = "/Inventory/CompositionType/ChangeName",
  Inventory_CompositionType_ChangeVat = "/Inventory/CompositionType/ChangeVat",
  Inventory_CompositionType_Delete = "/Inventory/CompositionType/Delete",
  Inventory_CompositionType_Get = "/Inventory/CompositionType/Get",
  Inventory_CompositionType_List = "/Inventory/CompositionType/List",
  Inventory_CompositionType_ListNl = "/Inventory/CompositionType/ListNl",
  Inventory_CompositionType_SetCompositionType = "/Inventory/CompositionType/SetCompositionType",
  Inventory_CompositionType_SetValue_$id$ = "/Inventory/CompositionType/SetValue/$id$",
  Inventory_Configuration_Add = "/Inventory/Configuration/Add",
  Inventory_Configuration_ChangeName = "/Inventory/Configuration/ChangeName",
  Inventory_Configuration_Delete = "/Inventory/Configuration/Delete",
  Inventory_Configuration_Get = "/Inventory/Configuration/Get",
  Inventory_Configuration_List = "/Inventory/Configuration/List",
  Inventory_ConfigurationBuilder_Add = "/Inventory/ConfigurationBuilder/Add",
  Inventory_ConfigurationBuilder_List = "/Inventory/ConfigurationBuilder/List",
  Inventory_ConfigurationBuilder_SetSpecial = "/Inventory/ConfigurationBuilder/SetSpecial",
  Inventory_Event_Add = "/Inventory/Event/Add",
  Inventory_Event_AddMany = "/Inventory/Event/AddMany",
  Inventory_Event_ChangeName = "/Inventory/Event/ChangeName",
  Inventory_Event_ChangePublicResponseTime = "/Inventory/Event/ChangePublicResponseTime",
  Inventory_Event_ChangeTime = "/Inventory/Event/ChangeTime",
  Inventory_Event_Delete = "/Inventory/Event/Delete",
  Inventory_Event_Download = "/Inventory/Event/Download",
  Inventory_Event_Downloads = "/Inventory/Event/Downloads",
  Inventory_Event_Get = "/Inventory/Event/Get",
  Inventory_Event_GetCreationAllowance = "/Inventory/Event/GetCreationAllowance",
  Inventory_Event_GetCurrentOrNext = "/Inventory/Event/GetCurrentOrNext",
  Inventory_Event_GetDisabledLocations = "/Inventory/Event/GetDisabledLocations",
  Inventory_Event_GetEmployeeAvailability = "/Inventory/Event/GetEmployeeAvailability",
  Inventory_Event_GetEmployeeOrders = "/Inventory/Event/GetEmployeeOrders",
  Inventory_Event_GetEventSummary = "/Inventory/Event/GetEventSummary",
  Inventory_Event_GetExtendedEvent = "/Inventory/Event/GetExtendedEvent",
  Inventory_Event_GetEventDelta = "/Inventory/Event/GetEventDelta",
  Inventory_Event_GetPrivatePublicEvents = "/Inventory/Event/GetPrivatePublicEvents",
  Inventory_Event_GetPublicEvents = "/Inventory/Event/GetPublicEvents",
  Inventory_Event_List = "/Inventory/Event/List",
  Inventory_Event_SendEmployeeEventResponse = "/Inventory/Event/SendEmployeeEventResponse",
  Inventory_Event_SetLocationConfigs = "/Inventory/Event/SetLocationConfigs",
  Inventory_Event_SetPublicVariable = "/Inventory/Event/SetPublicVariable",
  Inventory_Event_Upsert = "/Inventory/Event/Upsert",
  Inventory_General_GetDashboardData = "/Inventory/General/GetDashboardData",
  Inventory_General_GetDashboardStats = "/Inventory/General/GetDashboardStats",
  Inventory_General_OnlineCheck = "/Inventory/General/OnlineCheck",
  Inventory_InterchangeableComponent_List = "/Inventory/InterchangeableComponent/List",
  Inventory_Item_Add = "/Inventory/Item/Add",
  Inventory_Item_ChangeName = "/Inventory/Item/ChangeName",
  Inventory_Item_Delete = "/Inventory/Item/Delete",
  Inventory_Item_Get = "/Inventory/Item/Get",
  Inventory_Item_GetEventSourcingCosts = "/Inventory/Item/GetEventSourcingCosts",
  Inventory_Item_GetEventsSourcingCosts = "/Inventory/Item/GetEventsSourcingCosts",
  Inventory_Item_List = "/Inventory/Item/List",
  Inventory_Item_SetSourceDetail = "/Inventory/Item/SetSourceDetail",
  Inventory_Item_SetUnit = "/Inventory/Item/SetUnit",
  Inventory_Location_Add = "/Inventory/Location/Add",
  Inventory_Location_ChangeName = "/Inventory/Location/ChangeName",
  Inventory_Location_ClientList = "/Inventory/Location/ClientList",
  Inventory_Location_ClientList__v2025_4 = "/v2025.4/Inventory/Location/ClientList",
  Inventory_Location_Delete = "/Inventory/Location/Delete",
  Inventory_Location_Get = "/Inventory/Location/Get",
  Inventory_Location_GetCompanyLocations = "/Inventory/Location/GetCompanyLocations",
  Inventory_Location_List = "/Inventory/Location/List",
  Inventory_Location_PushLocation = "/Inventory/Location/PushLocation",
  Inventory_Location_SetDefaultEmployeeCount = "/Inventory/Location/SetDefaultEmployeeCount",
  Inventory_Location_SetLocationConfig = "/Inventory/Location/SetLocationConfig",
  Inventory_Location_SetOrder = "/Inventory/Location/SetOrder",
  Inventory_Location_SetSalaryModifier_$id$ = "/Inventory/Location/SetSalaryModifier/$id$",
  Inventory_Location_SetTipShare = "/Inventory/Location/SetTipShare",
  Inventory_Location_SetValue = "/Inventory/Location/SetValue",
  Inventory_Override_Composition = "/Inventory/Override/Composition",
  Inventory_Override_Tag = "/Inventory/Override/Tag",
  Inventory_Tag_Add = "/Inventory/Tag/Add",
  Inventory_Tag_ChangeColor = "/Inventory/Tag/ChangeColor",
  Inventory_Tag_ChangeName = "/Inventory/Tag/ChangeName",
  Inventory_Tag_Delete = "/Inventory/Tag/Delete",
  Inventory_Tag_Get = "/Inventory/Tag/Get",
  Inventory_Tag_List = "/Inventory/Tag/List",
  Inventory_Tag_SetFilter = "/Inventory/Tag/SetFilter",
  Inventory_Tag_SetOrder = "/Inventory/Tag/SetOrder",
  Legal_Settings_IsConfigured = "/Legal/Settings/IsConfigured",
  Legal_Settings_List = "/Legal/Settings/List",
  Legal_Settings_SelectProvider = "/Legal/Settings/SelectProvider",
  Legal_Settings_SetCredentials = "/Legal/Settings/SetCredentials",
  Legal_TSS_ChangeState = "/Legal/TSS/ChangeState",
  Legal_TSS_Create = "/Legal/TSS/Create",
  Legal_TSS_GetCurrent = "/Legal/TSS/GetCurrent",
  Legal_TSS_History = "/Legal/TSS/History",
  Legal_TSS_ReInitialize = "/Legal/TSS/ReInitialize",
  Mailing_Submission__v2025_4 = "/v2025.4/Mailing/Submission",
  Management_Changelog_Add = "/Management/Changelog/Add",
  Management_Changelog_Delete = "/Management/Changelog/Delete",
  Management_Changelog_Reactivate = "/Management/Changelog/Reactivate",
  Management_Changelog_Update = "/Management/Changelog/Update",
  Management_Company__v2025_4 = "/v2025.4/Management/Company",
  Management_Company_$id$_v2025_4 = "/v2025.4/Management/Company/$id$",
  Management_Company_ChangeName = "/Management/Company/ChangeName",
  Management_Company_Delete = "/Management/Company/Delete",
  Management_Company_Get = "/Management/Company/Get",
  Management_Company_List = "/Management/Company/List",
  Management_Company_SetAddress_$id$ = "/Management/Company/SetAddress/$id$",
  Management_Company_SetAlias = "/Management/Company/SetAlias",
  Management_Company_SetMetadata_$id$ = "/Management/Company/SetMetadata/$id$",
  Management_Contract_Delete_$company$_$contract$ = "/Management/Contract/Delete/$company$/$contract$",
  Management_Contract_GetCompany_$company$ = "/Management/Contract/GetCompany/$company$",
  Management_Contract_GetCustomerValues_$company$ = "/Management/Contract/GetCustomerValues/$company$",
  Management_Contract_Set_$company$ = "/Management/Contract/Set/$company$",
  Management_Contract_Update_$company$_$contract$ = "/Management/Contract/Update/$company$/$contract$",
  Management_Device_Location = "/Management/Device/Location",
  // The alias DNS automation (#637). Owner → Integrationen → DNS picks the provider and hands over its token;
  // the GET NEVER answers the token — it is a catalogued secret — only which provider is selected, whether the
  // instance's own main record could be read (zone and target are mirrored from it) and what the ledger of
  // alias records looks like. `Reconcile` drives every pending/failed ledger row once, by hand.
  Management_Dns_GetProvider = "/Management/Dns/GetProvider",
  Management_Dns_Reconcile = "/Management/Dns/Reconcile",
  Management_Dns_SetProvider = "/Management/Dns/SetProvider",
  Management_Environment_Add = "/Management/Environment/Add",
  Management_Environment_Delete = "/Management/Environment/Delete",
  Management_Environment_Get = "/Management/Environment/Get",
  Management_Environment_List = "/Management/Environment/List",
  Management_Environment_Upsert = "/Management/Environment/Upsert",
  // The platform's own fiskaly managing organisation id (#608). Owner → Integrationen → Fiskaly writes it;
  // `ManagingOrganizationResolver` reads it ahead of the legacy protected-company fallback, and the GET says
  // which of the two answered so the card can report a legacy installation as such.
  Management_Fiskaly_GetManagingOrganization = "/Management/Fiskaly/GetManagingOrganization",
  // The shared fiskaly TEST organisations demo locations are placed under (#933), Owner → Integrationen.
  Management_Fiskaly_AddDemoOrganization = "/Management/Fiskaly/AddDemoOrganization",
  Management_Fiskaly_ListDemoOrganizations = "/Management/Fiskaly/ListDemoOrganizations",
  Management_Fiskaly_RemoveDemoOrganization_$id$ = "/Management/Fiskaly/RemoveDemoOrganization/$id$",
  Management_Fiskaly_IsConfigured = "/Management/Fiskaly/IsConfigured",
  Management_Fiskaly_SetCredentials = "/Management/Fiskaly/SetCredentials",
  Management_Fiskaly_SetManagingOrganization = "/Management/Fiskaly/SetManagingOrganization",
  Management_Fiskaly_UpsertShard_$id$ = "/Management/Fiskaly/UpsertShard/$id$",
  Management_Hangfire_Authorize = "/Management/Hangfire/Authorize",
  // The owner-area, shard-scoped twins of the `Legal_*` routes above (#633). A `PlatformOwner` who has entered
  // a tenant context loses the `PlatformOwner` role by design (context narrowing), so the tenant routes can
  // never be reached as an owner from `/legal/settings`/`/legal/tss` — these routes let the OWNER area manage
  // a shard's legal settings and TSE with the shard id carried explicitly instead of implied by context.
  // Same bodies/behaviour as their `Legal_*` counterparts (incl. the #629 provider-switch error codes).
  Management_Legal_Settings_IsConfigured = "/management/legal/$shardId$/settings/configured",
  Management_Legal_Settings_List = "/management/legal/$shardId$/settings",
  Management_Legal_Settings_SelectProvider = "/management/legal/$shardId$/settings/provider",
  Management_Legal_Settings_SetCredentials = "/management/legal/$shardId$/settings/credentials",
  Management_Legal_TSS_ChangeState = "/management/legal/$shardId$/tss/state",
  Management_Legal_TSS_Create = "/management/legal/$shardId$/tss",
  Management_Legal_TSS_GetCurrent = "/management/legal/$shardId$/tss",
  Management_Legal_TSS_History = "/management/legal/$shardId$/tss/history",
  Management_Legal_TSS_ReInitialize = "/management/legal/$shardId$/tss/reinitialize",
  Management_Permission_GenerateTsEndpoints = "/Management/Permission/GenerateTsEndpoints",
  // The non-integration platform-wide settings (#608): the public base URL and the register app's advertised
  // version/build. Owner → Plattform. `SetSettings` takes the same object the GET answers, all fields optional.
  Management_Platform_GetSettings = "/Management/Platform/GetSettings",
  Management_Platform_SetSettings = "/Management/Platform/SetSettings",
  Management_SumUp_GetAffiliateKey = "/Management/SumUp/GetAffiliateKey",
  Management_SumUp_SetAffiliateKey = "/Management/SumUp/SetAffiliateKey",
  // The platform Telegram auth bot (#608). The GET NEVER answers the token — it is a catalogued secret — only
  // whether one is stored and, when the bot handle is already cached, which bot it belongs to.
  Management_Telegram_GetAuthBot = "/Management/Telegram/GetAuthBot",
  Management_Telegram_SetAuthBotToken = "/Management/Telegram/SetAuthBotToken",
  Management_Permission_GenerateTsPermissionSets = "/Management/Permission/GenerateTsPermissionSets",
  Management_Setup_IsAlive = "/Management/Setup/IsAlive",
  Management_Shard__v2025_4 = "/v2025.4/Management/Shard",
  Management_Shard_$id$_v2025_4 = "/v2025.4/Management/Shard/$id$",
  Management_Shard_Company_$company$_v2025_4 = "/v2025.4/Management/Shard/Company/$company$",
  Management_Shard_Delete = "/Management/Shard/Delete",
  Management_Shard_Get = "/Management/Shard/Get",
  Management_Shard_List = "/Management/Shard/List",
  Management_Shard_SetMetadata_$id$ = "/Management/Shard/SetMetadata/$id$",
  Management_User_Create = "/Management/User/Create",
  Management_User_Delete = "/Management/User/Delete",
  Management_User_List = "/Management/User/List",
  Miscellaneous_Changelog_List = "/Miscellaneous/Changelog/List",
  Miscellaneous_Support_GetSupportContact = "/Miscellaneous/Support/GetSupportContact",
  Payment_Settings_BookingReferenceType = "/Payment/Settings/BookingReferenceType",
  Payment_Settings_Get = "/Payment/Settings/Get",
  Payment_Settings_IsConfigured = "/Payment/Settings/IsConfigured",
  Payment_Settings_SelectProvider = "/Payment/Settings/SelectProvider",
  Payment_Settings_SetCredentials_$provider$ = "/Payment/Settings/SetCredentials/$provider$",
  Token_Basic__v2025_4 = "/v2025.4/Token/Basic",
  // Fiscal job engine (#768) — the queryable surface every long-running fiscal operation sits on. The hub at
  // /hubs/fiscal-jobs only says "job X advanced"; the state is always read from here.
  Fiscal_Jobs_Create = "/fiscal/jobs/Create",
  Fiscal_Jobs_List = "/fiscal/jobs/List",
  Fiscal_Jobs_Get = "/fiscal/jobs/Get",
  Fiscal_Jobs_RetryItem = "/fiscal/jobs/RetryItem",
  // DSFinV-K data exports (#770). Listing past exports is Fiscal_Jobs_List with kind=dataExport — the engine's
  // own queryable record — so only what the engine cannot answer lives here: the filter's options, the
  // validated create, and the file itself. Download is a plain read of a stored result, never a rebuild.
  Fiscal_Exports_Registers = "/fiscal/exports/Registers",
  Fiscal_Exports_Create = "/fiscal/exports/Create",
  Fiscal_Exports_Download = "/fiscal/exports/Download",
  // TSE data exports (#776) — the second export § 4 KassenSichV names, beside the DSFinV-K one above.
  // Listing past runs is Fiscal_Jobs_List with kind=tseExport, for the same reason. There is deliberately no
  // "Registers" call here: this export is never narrowed to a register, so there is nothing to pick.
  Fiscal_TseExports_Create = "/fiscal/tse-exports/Create",
  Fiscal_TseExports_Download = "/fiscal/tse-exports/Download",
  // Correcting filed cash point closings (#771). The runs are fiscal jobs of kind closingCorrection, so listing,
  // reading and retrying them is Fiscal_Jobs_*; the registers filter reuses Fiscal_Exports_Registers.
  Fiscal_ClosingCorrections_Candidates = "/fiscal/closing-corrections/Candidates",
  Fiscal_ClosingCorrections_Create = "/fiscal/closing-corrections/Create",
  // Forms service — canonical definition CRUD. The `/api/forms` prefix is owned by the Forms service routes
  // themselves, so the gateway (dev nginx / prod nginx) only has to route the prefix to service_forms.
  Forms_Definition__v2025_1 = "/api/forms/v2025.1/definition",
  Forms_Submission__v2025_1 = "/api/forms/v2025.1/submission",
  Forms_Requirement__v2025_1 = "/api/forms/v2025.1/requirement",
  // DeviceService — web-managed PoS app configuration. The `/api/devices` prefix is owned by the DeviceService
  // routes themselves, so the gateway only has to route the prefix to service_device.
  DeviceConfig__v2026_6 = "/api/devices/v2026.6/configuration",
  // DeviceService — device fiscal-lifecycle management (acquisition date, decommissioning).
  Device_Lifecycle__v2026_6 = "/api/devices/v2026.6/lifecycle"
}
